// tslint:disable:max-line-length
import { PaintPresetModel } from 'src/app/edit/models/paint-preset.model';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { ScalarFresnelModel } from 'src/app/edit/models/scalar-fresnel.model';

enum PaintGroups {
  Colors = 'Colors',
  Effects = 'Effects'
}

enum PaintIcons {
  Colors = '_color',
  Effects = 'adjust'
}


// Colors
export const PaintPresetOriginal = new PaintPresetModel('Original', new ColorRecipeModel({ tintColor: false, saturation: false, contrast: false, brightness: false, opacity: false }), 'times-circle', PaintGroups.Colors);
export const PaintPresetBlack = new PaintPresetModel('Black', { tintColor: [0, 0, 0], saturation: false, contrast: false, brightness: false, opacity: false }, PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetRed = new PaintPresetModel('Red', { tintColor: [1, 0, 0], saturation: false, contrast: false, brightness: false, opacity: false }, PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetYellow = new PaintPresetModel('Yellow', new ColorRecipeModel({ tintColor: [1, 1, 0], saturation: false, contrast: false, brightness: false, opacity: false }), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetGreen = new PaintPresetModel('Green', new ColorRecipeModel({ tintColor: [0, 1, 0], saturation: false, contrast: false, brightness: false, opacity: false }), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetCyan = new PaintPresetModel('Cyan', new ColorRecipeModel({ tintColor: [0, 1, 1], saturation: false, contrast: false, brightness: false, opacity: false }), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetBlue = new PaintPresetModel('Blue', new ColorRecipeModel({ tintColor: [0, 0, 1], saturation: false, contrast: false, brightness: false, opacity: false }), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetPink = new PaintPresetModel('Pink', new ColorRecipeModel({ tintColor: [1, 0, 1], saturation: false, contrast: false, brightness: false, opacity: false }), PaintIcons.Colors, PaintGroups.Colors);

// Effects
export const PaintPresetGrayscale = new PaintPresetModel('Grayscale', new ColorRecipeModel({ tintColor: false, saturation: -100, contrast: false, brightness: false, opacity: false }), PaintIcons.Effects, PaintGroups.Effects);
export const PaintPresetDesaturated = new PaintPresetModel('Desaturated', new ColorRecipeModel({ tintColor: false, saturation: -50, contrast: false, brightness: false, opacity: false }), PaintIcons.Effects, PaintGroups.Effects);
export const PaintPresetFade = new PaintPresetModel('Fade', new ColorRecipeModel({ tintColor: [0, 0, 0], contrast: false, brightness: 55, saturation: -100, opacity: new ScalarFresnelModel({ edge: 1, center: 0, edgeBias: 0, centerBias: 1, power: 1 }) }), PaintIcons.Effects, PaintGroups.Effects);

// Tint Color Presets
export const PaintTintColorPresets = [
  PaintPresetBlack,
  PaintPresetRed,
  PaintPresetYellow,
  PaintPresetGreen,
  PaintPresetCyan,
  PaintPresetBlue,
  PaintPresetPink
];

// Complete Paint Preset Set
export const PaintPresets = [
  PaintPresetOriginal,
  ...PaintTintColorPresets,
  PaintPresetGrayscale,
  PaintPresetDesaturated,
  PaintPresetFade
];

